import { render } from "./CalendarSelect.vue?vue&type=template&id=473f2284&scoped=true"
import script from "./CalendarSelect.vue?vue&type=script&lang=js"
export * from "./CalendarSelect.vue?vue&type=script&lang=js"

import "./CalendarSelect.vue?vue&type=style&index=0&id=473f2284&lang=scss&scoped=true"

import exportComponent from "/home/douglas/Rwi/surefooted-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-473f2284"]])

export default __exports__